import dayjs from "dayjs";
import { MessageCircle, MoreHorizontal, Share2, ThumbsUp } from "lucide-react";

import { Avatar } from "@/components/avatar";

import type { ScheduledPost } from "../scheduledPost";

import { PostCaption } from "./PostCaption";
import { PostImage } from "./PostImage";

const ACTIONS = [
  { icon: ThumbsUp, label: "Like" },
  { icon: MessageCircle, label: "Comment" },
  { icon: Share2, label: "Share" },
];

export function FacebookPostPreview({ post }: { post: ScheduledPost }) {
  return (
    <article
      aria-label="Facebook preview"
      className="overflow-hidden rounded-lg border border-border-secondary bg-bg-primary text-text-primary"
    >
      <div className="flex items-center gap-md p-md">
        <Avatar
          alt={post.account.name}
          className="size-10 rounded-full"
          initials={post.account.name.slice(0, 2).toUpperCase()}
        />
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-semibold">{post.account.name}</p>
          <p className="truncate text-xs text-text-tertiary">
            {dayjs(post.scheduledAt).format("MMM D [at] h:mm A")}
          </p>
        </div>
        <MoreHorizontal className="size-5 text-fg-quaternary" />
      </div>

      <p className="px-md pb-md text-sm">
        <PostCaption caption={post.caption} />
      </p>

      <PostImage post={post} />

      <div className="grid grid-cols-3 border-t border-border-secondary">
        {ACTIONS.map(({ icon: Icon, label }) => (
          <span
            className="flex items-center justify-center gap-xs py-md text-sm font-medium text-text-tertiary"
            key={label}
          >
            <Icon className="size-5" />
            {label}
          </span>
        ))}
      </div>
    </article>
  );
}
